import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mixpanel } from 'components/MixPanel/MixPanel';
import { trackUnstruct } from 'components/SnowplowTracker/SnowplowTracker';
import { trackGoogleTagManagerEvent as gtmPush } from 'components/GoogleTagManager/GoogleTagManager';
var userId;
var deviceType;
export var setUserId = function setUserId(id) {
  return userId = id;
};
export var setDeviceType = function setDeviceType(type) {
  return deviceType = type;
};
export var ec = function ec() {
  trackUnstruct(arguments.length >= 1 && (arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 0 ? undefined : arguments[0] : '', _objectSpread({
    app_platform: 'web'
  }, arguments.length >= 2 && (arguments.length <= 1 ? undefined : arguments[1]) ? arguments.length <= 1 ? undefined : arguments[1] : {}, userId ? {
    user_id: String(userId)
  } : {}, deviceType ? {
    device_type: deviceType
  } : {}));
  mixpanel.track.apply(mixpanel, arguments);
};
export var ga = function ga(eventCategory, eventAction) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var eventLabel = args[0],
      eventValue = args[1],
      options = args[2];
  gtmPush({
    event: 'gaEvent',
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: eventValue || 0,
    eventNI: options && options.nonInteraction || false
  });
  trackUnstruct("".concat(eventCategory, " - ").concat(eventAction), _objectSpread({
    app_platform: 'web'
  }, args.length >= 1 && args[0] ? {
    eventLabel: args[0]
  } : {}, args.length >= 2 && args[1] ? {
    eventValue: args[1]
  } : {}, args.length >= 3 && args[2] && args[2].nonInteraction ? {
    nonInteraction: true
  } : {}, userId ? {
    user_id: String(userId)
  } : {}));
};